module.exports = __webpack_public_path__ + "static/media/future_02.4a23e731.png";